import { mireExplorerStore } from '#lib/stores/mireExplorerStore.svelte.js';
import {
	deriveActiveSymbology,
	roadSealHints,
	type SymbologyItem
} from '#lib/components/map/legend/symbology.js';

export function mireActiveSymbology(
	features: Array<{ properties: Record<string, unknown> | null }>
): SymbologyItem[] {
	const { lineColorExpression, stepLabels } = mireExplorerStore;
	// No field symbolised yet.
	if (!Array.isArray(lineColorExpression) || !lineColorExpression.length) return [];
	return deriveActiveSymbology(
		{ type: 'line', paint: { 'line-color': lineColorExpression } },
		{ stepLabels, extraItems: roadSealHints([2, 1]) },
		features
	);
}
